import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "leftPart"
};
const _hoisted_2 = {
  class: "labelNumberSpeach"
};
const _hoisted_3 = {
  key: 0,
  class: "filterSearch"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "dialog-footer"
};
const _hoisted_7 = {
  class: "loadingContainer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_input = _resolveComponent("w-input");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_affix = _resolveComponent("el-affix");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_AddCard = _resolveComponent("AddCard");
  const _component_IconButton = _resolveComponent("IconButton");
  const _component_standard_speach_card = _resolveComponent("standard-speach-card");
  const _component_draggable = _resolveComponent("draggable");
  const _component_el_button = _resolveComponent("el-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  const _component_loader = _resolveComponent("loader");
  const _component_infinite_loading = _resolveComponent("infinite-loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_affix, {
    offset: 80,
    onChange: _ctx.onFixChange
  }, {
    default: _withCtx(() => [_ctx.filter ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["filterBar", _ctx.fixeBar ? 'fix' : ''])
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_createVNode(_Transition, {
      name: "fade"
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.totalSpeach > 1 ? _ctx.$t('speachGrid.totalPlural', {
        total: _ctx.totalSpeach
      }) : _ctx.$t('speachGrid.total', {
        total: _ctx.totalSpeach
      })), 513), [[_vShow, _ctx.totalSpeach > 0 || !_ctx.publishFilter && !_ctx.changeOrderFilter && !_ctx.filterByName]])]),
      _: 1
    })]), _ctx.filterByName ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_w_input, {
      modelValue: _ctx.filterName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.filterName = $event),
      placeholder: _ctx.$t('speachGrid.search'),
      clearable: "",
      onInput: _cache[1] || (_cache[1] = $event => _ctx.debouncedSearch())
    }, {
      prefix: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify"
      })]),
      _: 1
    }, 8, ["modelValue", "placeholder"])])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_ctx.changeOrderFilter ? (_openBlock(), _createBlock(_component_el_radio_group, {
      key: 0,
      class: "filter",
      modelValue: _ctx.selectedFilterSort,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.selectedFilterSort = $event),
      size: "small",
      onChange: _ctx.reinitSearch
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_button, {
        size: "default",
        value: _ctx.dateFilter
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(_ctx.dateFilterLabel)), 1)]),
        _: 1
      }, 8, ["value"]), _createVNode(_component_el_radio_button, {
        size: "default",
        value: "TITLE"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('speachGrid.filter.title')), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onChange"])) : _createCommentVNode("", true), _ctx.publishFilter ? (_openBlock(), _createBlock(_component_el_radio_group, {
      key: 1,
      class: "filter",
      modelValue: _ctx.filterEtat,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.filterEtat = $event),
      size: "small",
      onChange: _ctx.reinitSearch
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_button, {
        size: "default",
        value: "NONE"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('speachGrid.filter.all')), 1)]),
        _: 1
      }), _createVNode(_component_el_radio_button, {
        size: "default",
        value: "NON_PUBLIE"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('speachGrid.filter.unpublish')), 1)]),
        _: 1
      }), _createVNode(_component_el_radio_button, {
        size: "default",
        value: "PUBLIE"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('speachGrid.filter.publish')), 1)]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onChange"])) : _createCommentVNode("", true), _ctx.changeOrderFilter || _ctx.publishFilter ? (_openBlock(), _createBlock(_component_el_radio_group, {
      key: 2,
      class: "filter",
      modelValue: _ctx.filterOrder,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.filterOrder = $event),
      size: "small",
      onChange: _ctx.reinitSearch
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_button, {
        size: "default",
        value: "ASC"
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "arrow-up"
        })]),
        _: 1
      }), _createVNode(_component_el_radio_button, {
        size: "default",
        value: "DESC"
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          icon: "arrow-down"
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onChange"])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["onChange"]), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_withDirectives(_createVNode(_component_el_empty, {
      class: "emptyPanel",
      description: _ctx.$t('speachGrid.noResult')
    }, null, 8, ["description"]), [[_vShow, _ctx.isEmptyResult && _ctx.emptyState]])]),
    _: 1
  }), _createElementVNode("div", {
    class: _normalizeClass(["speachGridContainer", _ctx.forceInline ? 'forceInline' : ''])
  }, [_ctx.addCard ? (_openBlock(), _createBlock(_component_AddCard, {
    key: 0,
    icon: _ctx.addCardIcon,
    label: _ctx.labelAddCard,
    url: _ctx.urlAddCard
  }, null, 8, ["icon", "label", "url"])) : _createCommentVNode("", true), _ctx.draggable ? (_openBlock(), _createBlock(_component_draggable, {
    key: 1,
    modelValue: _ctx.listOfSpeach,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.listOfSpeach = $event),
    "item-key": "speachID",
    onChange: _ctx.changeSpeachesOrder
  }, {
    item: _withCtx(({
      element: speach,
      index
    }) => [_createVNode(_component_standard_speach_card, {
      speach: speach,
      class: _normalizeClass(["speachCard", _ctx.getClass(index)]),
      style: _normalizeStyle('margin-bottom:' + _ctx.lineSpace + 'px'),
      loadRegulated: _ctx.loadRegulated,
      commentsEnabled: _ctx.commentsEnabled,
      "add-button": _ctx.addButton,
      "remove-button": _ctx.removeButton,
      "speach-date-to-display": _ctx.dateFilter,
      onAddSpeachTo: _cache[5] || (_cache[5] = $event => _ctx.addSpeachTo($event)),
      onRemoveSpeachFrom: _cache[6] || (_cache[6] = $event => _ctx.removeSpeachFrom($event))
    }, {
      middleSlot: _withCtx(() => [_ctx.addButton ? (_openBlock(), _createBlock(_component_IconButton, {
        key: 0,
        style: {
          "margin-right": "8px"
        },
        color: "white",
        size: "small",
        "class-name": "padded",
        icon: "plus",
        text: _ctx.$t('speachGrid.addToPath'),
        onClick: $event => _ctx.addSpeachTo(speach.speachID)
      }, null, 8, ["text", "onClick"])) : _createCommentVNode("", true), _ctx.removeButton ? (_openBlock(), _createBlock(_component_IconButton, {
        key: 1,
        style: {
          "margin-right": "8px"
        },
        color: "white",
        size: "small",
        "class-name": "padded",
        icon: "minus",
        text: _ctx.$t('speachGrid.removeFromPath'),
        onClick: $event => _ctx.removeSpeachFrom(speach.speachID)
      }, null, 8, ["text", "onClick"])) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["speach", "class", "style", "loadRegulated", "commentsEnabled", "add-button", "remove-button", "speach-date-to-display"])]),
    _: 1
  }, 8, ["modelValue", "onChange"])) : (_openBlock(true), _createElementBlock(_Fragment, {
    key: 2
  }, _renderList(_ctx.listOfSpeach, (speach, index) => {
    return _openBlock(), _createBlock(_component_standard_speach_card, {
      key: speach.speachID,
      speach: speach,
      class: _normalizeClass(["speachCard", _ctx.getClass(index)]),
      style: _normalizeStyle('margin-bottom:' + _ctx.lineSpace + 'px'),
      loadRegulated: _ctx.loadRegulated,
      commentsEnabled: _ctx.commentsEnabled,
      "speach-date-to-display": _ctx.dateFilter,
      "add-button": _ctx.addButton,
      "remove-button": _ctx.removeButton,
      onAddSpeachTo: _cache[8] || (_cache[8] = $event => _ctx.addSpeachTo($event)),
      onRemoveSpeachFrom: _cache[9] || (_cache[9] = $event => _ctx.removeSpeachFrom($event))
    }, {
      middleSlot: _withCtx(() => [_ctx.addButton ? (_openBlock(), _createBlock(_component_IconButton, {
        key: 0,
        style: {
          "margin-right": "8px"
        },
        color: "white",
        size: "small",
        "class-name": "padded",
        icon: "plus",
        text: _ctx.$t('speachGrid.addToPath'),
        onClick: $event => _ctx.addSpeachTo(speach.speachID)
      }, null, 8, ["text", "onClick"])) : _createCommentVNode("", true), _ctx.removeButton ? (_openBlock(), _createBlock(_component_IconButton, {
        key: 1,
        style: {
          "margin-right": "8px"
        },
        color: "white",
        size: "small",
        "class-name": "padded",
        icon: "minus",
        text: _ctx.$t('speachGrid.removeFromPath'),
        onClick: $event => _ctx.removeSpeachFrom(speach.speachID)
      }, null, 8, ["text", "onClick"])) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["speach", "class", "style", "loadRegulated", "commentsEnabled", "speach-date-to-display", "add-button", "remove-button"]);
  }), 128))], 2), _createVNode(_component_w_dialog, {
    visible: _ctx.confirmRemoveSpeachId !== ''
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
      onClick: _cache[10] || (_cache[10] = $event => _ctx.confirmRemoveSpeachId = '')
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('speachGrid.removal.cancel')), 1)]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.confirmRemoveSpeachFrom
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('speachGrid.removal.confirm')), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_ctx.confirmRemoveAccess ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('speachGrid.removal.removalMessage')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('speachGrid.removal.removalMessageWithWarning')), 1))]),
    _: 1
  }, 8, ["visible"]), _createVNode(_component_infinite_loading, {
    identifier: _ctx.gridID,
    distance: 250,
    onInfinite: _ctx.infiniteHandler
  }, {
    "no-more": _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("div", null, null, -1)]))]),
    spinner: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_loader)])]),
    _: 1
  }, 8, ["identifier", "onInfinite"])], 64);
}